import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gerar-lote',
  templateUrl: './gerar-lote.component.html',
  styleUrls: ['./gerar-lote.component.css']
})
export class GerarLoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
